import React from "react";
import { ReactSVG } from "react-svg";

import classes from "./SmIconsPopOverChildren.module.css";

const SmIconsPopOverChildren = ({ icons, setIcons, galleryArray }) => {
  // handleAddOrRemoveIcon
  const handleAddOrRemoveIcon = async (ic) => {
    if (icons.includes(ic)) setIcons((p) => p.filter((e) => e !== ic));
    else {
      if (icons?.length === 4) return;
      setIcons((p) => [...p, ic]);
    }
  };

  return (
    <div className={classes?.container}>
      {galleryArray?.map((ic, i) => {
        return (
          <div
            key={i}
            className={`${classes?.iconBox} ${
              icons.includes(ic) && classes?.selectedIconBox
            }`}
            onClick={handleAddOrRemoveIcon.bind(this, ic)}
          >
            <img src={ic} className={classes?.smIcon} draggable={false} />
          </div>
        );
      })}
    </div>
  );
};

export default SmIconsPopOverChildren;
